// Extract the tenant slug from the page hostname.
//
// Examples:
//   acme.lvh.me:3000        → "acme"
//   acme.serbia-shop.com    → "acme"
//   serbia-shop.com         → null  (root domain)
//   lvh.me:3000             → null
//   localhost:3000          → null  (single label)
//   127.0.0.1:3000          → null  (IP)
//
// On the root domain (null slug) the storefront has no tenant context —
// the app should redirect to a marketing/landing page or to a default
// shop. For now we expose null and let the consumer decide.

const ROOT_DOMAINS = ['lvh.me', 'serbia-shop.com'];
const RESERVED_SUBDOMAINS = new Set(['www', 'api', 'admin']);

export const slugFromHost = (host: string = window.location.host): string | null => {
  const hostname = host.split(':')[0];
  if (/^\d+\.\d+\.\d+\.\d+$/.test(hostname)) return null;
  for (const root of ROOT_DOMAINS) {
    if (hostname === root) return null;
    if (hostname.endsWith(`.${root}`)) {
      const sub = hostname.slice(0, -(root.length + 1));
      if (!sub || sub.includes('.')) return null; // nested or empty
      if (RESERVED_SUBDOMAINS.has(sub)) return null;
      return sub;
    }
  }
  return null;
};

export const TENANT_SLUG = slugFromHost();
